import gql from 'graphql-tag';
import {
  CheckoutTotalAmountFields,
  core_apimessages_CheckoutLineItem_Type as CheckoutLineItemType,
} from '../schemas/rql';

type Checkout = CheckoutTotalAmountFields.Fragment;

function findAmountOwedLineItem(lineItems: CheckoutTotalAmountFields.LineItems[]) {
  return lineItems.find((lineItem) => lineItem.type === CheckoutLineItemType.AMOUNT_OWED);
}

export function findAmountOwed(checkout: Checkout) {
  const { amountCents, currency } = findAmountOwedLineItem(checkout.lineItems).amount;
  return { amountCents, currency };
}

export const CheckoutTotalAmountFragment = gql`
  fragment CheckoutTotalAmountFields on Checkout {
    _id
    lineItems {
      type
      amount {
        amountCents
        currency
      }
    }
  }
`;
